window.debug = function() {
    if (process.env.DEBUG == 'true' || process.env.NODE_ENV =='development') {
        console.log.apply(console, arguments);
    }
}

window.IS_DEV = () => {
    return process.env.NODE_ENV != 'production';
}
